<template>

</template>

<script>

export default {
  title: "New",
  access_code: "IWF_NEW01",
  created() {
      this.$router.push("/isWorkForm/request")
  }
};
</script>

<style>
</style>